import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

import Modal from "../../../../../../../components/Generic/Modal";

export const StyledModal = styled(Modal)(() => ({}));

export const Section = styled("section")(() => ({
  paddingTop: "1rem",
  width: "100%",
}));

export const styles = makeStyles(() => ({
  error: {
    flexWrap: "nowrap",
    whiteSpace: "nowrap",
  },
}));
